import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import {
  AlertTitle,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Modal,
} from "@mui/material";
//*files
import cssClasses from "./CancelUnitConfirmation.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { useSelector } from "react-redux";

//service

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import CustomRadio from "../../Subcomponents/CustomRadio";

const useStyles = makeStyles((theme) => ({
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));
// ??leadData=from global leadCards otherwise in data we get leadname
export default function CancelUnitConfirmation({
  open,
  handleClose,
  returnRes,
  data,
  cancellationRequest,
  leadData = null,
}) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  let isUserAccess = loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Waive Off Cancellation Charges"]?.isAccessible
  const [cancellationPercentageMsg, setCancellationPercentageMsg] =
    useState(null);
  const [waiveOffValue, setWaiveOffValue] = useState(false);
  const [updateUnitPrice, setUpdateUnitPrice] = useState({
    bsp: null,
    sdr: null,
    gst: null,
    total: null,
    cancellationCharges: 0,
    waive: false,
    newCancellationCharges: 0,
    waivedOffReason: "",
    waivedOffCancellationCharges: null,
  });
  const [helperText, setHelperText] = useState({
    bsp: "",
    sdr: "",
    gst: "",
    total: "",
    cancellationCharges: "",
    newCancellationCharges: "",
    waivedOffReason: "",
    waivedOffCancellationCharges: "",
  });
  const [openAlertBoxForCancellation, setOpenAlertBoxForCancellation] =
    useState(false);
  const [titleForAlert, setTitleForAlert] = useState(false);
  const [holdRefund, setHoldRefund] = useState(false);
  const [waiveOpt, setWaiveOpt] = useState(true)
  useEffect(() => {
    console.log(data);
    console.log("data?.unitCost?.gst", data?.unitCost?.gst)
    const priceObj = {
      bsp: data?.unitCost?.bsp ? data?.unitCost?.bsp : data?.unitcost?.bsp ? data?.unitcost?.bsp : null,
      sdr: data?.unitCost?.sdr ? data?.unitCost?.sdr : data?.unitcost?.sdr ? data?.unitcost?.sdr : null,
      gst: data?.unitCost?.gst ? data?.unitCost?.gst : data?.unitcost?.gst ? data?.unitcost?.gst : null,
      total: data?.unitCost?.total ? data?.unitCost?.total : data?.unitcost?.total ? data?.unitcost?.total : null,
      cancellationCharges: 0,
      waive: false,
      newCancellationCharges: 0,
      waivedOffReason: "",
      waivedOffCancellationCharges: null,
    };

    setUpdateUnitPrice(priceObj, data?.status);
    console.log("priceObj: ", priceObj);
  }, []);

  useEffect(() => {
    console.log({ data });
    //!!Cancellation charges needs to be adjusted in allotmentTransaction
    calculateCancellationCharges();
  }, []);
  function calculateCancellationCharges() {
    if (cancellationRequest?.cancelledinfarvision) {
      setUpdateUnitPrice((pre) => {
        pre.cancellationCharges = 0;
        return { ...pre };
      });
      setCancellationPercentageMsg(
        "Cancelled in Farvision."
      );

    } else {
      if (
        (data?.status === "Payment Complete" ||
          data?.status === "Partial Payment Done" ||
          data?.status === "Cancellation Pending" ||
          data?.status === "Cancellation Requested" ||
          data?.status === "Cancellation Not Done" ||
          // ! allotmentstatus is status from AllotmentPayment table; needed when accepting request in Cancellations tab
          data?.allotmentstatus === "Payment Complete" ||
          data?.allotmentstatus === "Partial Payment Done" ||
          data?.allotmentstatus === "Cancellation Pending" ||
          data?.allotmentstatus === "Cancellation Requested" ||
          data?.allotmentstatus === "Cancellation Not Done") &&
        (data?.firstpaymentdate !== null || data?.firstPaymentDate !== null)
      ) {
        // ??gives same value
        // var diffInSeconds = Math.abs(new Date(data?.firstPaymentDate).getTime() - new Date().getTime());
        // var days = Math.floor(diffInSeconds / 60 / 60 / 24/1000);
        let date = data?.pricingType === 'preselect' ? data.preselectConfirmationDate ? data.preselectConfirmationDate : data?.firstPaymentDate : data?.firstPaymentDate;
        var diffInSeconds =
          (data?.cancelUnitRequests?.length > 0 ? Math.abs(new Date(data?.cancelUnitRequests[0]?.created_at) - new Date(date)) : data?.cancelunitrequestcreatedat ? Math.abs(new Date(data?.cancelunitrequestcreatedat) - new Date(date)) : Math.abs(new Date(date) - new Date().valueOf())) /
          1000;
        var days = Math.floor(diffInSeconds / 60 / 60 / 24);
        if ((data?.farvisionstatus ? data?.farvisionstatus : data?.unitData?.farvisionStatus) === "Hold" || (data?.farvisionstatus ? data?.farvisionstatus : data?.unitData?.farvisionStatus) === "Hold") {
          setCancellationPercentageMsg(
            "Cancellation charges may apply"
          );
        } else {
          if (days < 15 || ((data.pricingtype ? data?.pricingtype : data?.pricingType) === 'preselect' && (data.preselectconfirmation ? data?.preselectconfirmation : data?.preselectConfirmation) === 'confirmation pending')) {
            setUpdateUnitPrice((pre) => {
              pre.cancellationCharges = 0;
              return { ...pre };
            });
            setCancellationPercentageMsg(
              "Cancellation charges are not applicable."
            );
          } else if (days >= 16 && days <= 30) {
            let charges = toCalculateValueFromPercent(1);
            setUpdateUnitPrice((pre) => {
              pre.cancellationCharges = charges ? charges : 0;
              return { ...pre };
            });
            if ((data.paidamount ? data?.paidamount : data?.paidAmount) >= charges) {
              setCancellationPercentageMsg(
                `The cancellation fee will be calculated as 1%(₹${Number(data?.unitcost?.bsp ? data?.unitcost?.bsp : data?.unitCost?.bsp) / 100}) of the unit cost.`
              );
            } else {
              setCancellationPercentageMsg(
                `Paid Amount ₹${numberWithCommas(
                  (data.paidamount ? data?.paidamount : data?.paidAmount)
                )} is less than cancellation charges ₹${numberWithCommas(charges)}`
              );
            }
          } else if (days > 30 && days <= 60) {
            let charges = toCalculateValueFromPercent(1.5);
            setUpdateUnitPrice((pre) => {
              pre.cancellationCharges = charges ? charges : 0;
              return { ...pre };
            });
            if ((data.paidamount ? data?.paidamount : data?.paidAmount) >= charges) {
              setCancellationPercentageMsg(
                `The cancellation fee will be calculated as 1.5%(₹${(Number(data?.unitcost?.bsp ? data?.unitcost?.bsp : data?.unitCost?.bsp) * 1.5) / 100}) of the unit cost.`
              );
            } else {
              setCancellationPercentageMsg(
                `Paid Amount ₹${numberWithCommas(
                  (data.paidamount ? data?.paidamount : data?.paidAmount)
                )} is less than cancellation charges ₹${numberWithCommas(charges)}`
              );
            }
          } else if (days >= 61) {
            let charges = toCalculateValueFromPercent(2);
            setUpdateUnitPrice((pre) => {
              pre.cancellationCharges = charges ? charges : 0;
              return { ...pre };
            });
            if ((data.paidamount ? data?.paidamount : data?.paidAmount) >= charges) {
              setCancellationPercentageMsg(
                `The cancellation fee will be calculated as 2%(₹${(Number(data?.unitcost?.bsp ? data?.unitcost?.bsp : data?.unitCost?.bsp) * 2) / 100}) of the unit cost.`
              );
            } else {
              setCancellationPercentageMsg(
                `Paid Amount ₹${numberWithCommas(
                  (data.paidamount ? data?.paidamount : data?.paidAmount)
                )} is less than cancellation charges ₹${numberWithCommas(charges)}`
              );
            }
          }
        }
      } else if (data?.status === "Payment Pending" || data?.allotmentstatus === "Payment Pending") {
        setCancellationPercentageMsg("Cancellation charges are not applicable.");
        setUpdateUnitPrice((pre) => {
          pre.cancellationCharges = 0;
          return { ...pre };
        });
      }
    }

  }

  function waiveOff(value) {
    setWaiveOffValue(value);
    if (value === true) {
      const payload = { ...updateUnitPrice };
      payload.waivedOffCancellationCharges = parseInt(payload.cancellationCharges);
      payload.newCancellationCharges = 0
      setUpdateUnitPrice(payload);
      setCancellationPercentageMsg(null);
      setWaiveOpt(true)
    } else {
      const payload = { ...updateUnitPrice };
      payload.waivedOffCancellationCharges = null;
      payload.newCancellationCharges = 0;
      payload.waivedOffReason = ""
      setUpdateUnitPrice(payload);
      calculateCancellationCharges();
      setWaiveOpt(true)
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  function toCalculateValueFromPercent(percentage) {
    var numVal1 = Number(data?.unitcost?.bsp ? data?.unitcost?.bsp : data?.unitCost?.bsp);
    var numVal2 = Number(percentage) / 100;

    var totalValue = numVal1 * numVal2;

    return Math.ceil(totalValue);
  }
  function save(buttonValue) {
    // !!For Update
    // if ((loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Update Cancel Unit Price"]?.isAccessible && !loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Cancellation Charges"]?.isAccessible) ||
    //   (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Update Cancel Unit Price"]?.isAccessible && loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Cancellation Charges"]?.isAccessible)) {
    // if (updateUnitPrice.bsp !== null && updateUnitPrice.sdr != null && updateUnitPrice.gst !== null && updateUnitPrice.cancellationCharges !== null) {
    // Net cancellation charge actually sent to payments/refund.
    //
    // The previous expression charged the FULL paid amount whenever the waiver
    // was greater than or equal to what the customer had paid — so a 100% waiver
    // on a charge larger than the payment retained everything instead of
    // refunding it. Replayed over all 3,435 cancellations this changed 11 of
    // them: 9 that were over-charged (none correct) and 2 that produced -0.5
    // from rounding; the other 3,303 are unaffected.
    //
    // charge - waived, floored at 0 (waiver can exceed the charge) and capped at
    // what was actually paid (never retain more than the customer gave us).
    // same fallback the previous expression used — unchanged on purpose
    const paidAmount = Number(
      (data.paidamount ? data?.paidamount : data?.paidAmount) || 0
    );
    const grossCharge = Number(updateUnitPrice?.cancellationCharges || 0);
    const waivedCharge = Number(updateUnitPrice?.waivedOffCancellationCharges || 0);
    const netCancellationCharge = Math.max(
      0,
      Math.min(paidAmount, grossCharge - waivedCharge)
    );

    let objChange = {
      bsp: updateUnitPrice?.bsp,
      gst: updateUnitPrice?.gst,
      sdr: updateUnitPrice?.sdr,
      total: updateUnitPrice?.total,
      cancellationCharges: netCancellationCharge,
    };
    console.log({ objChange });
    returnRes(objChange, buttonValue, waiveOffValue, updateUnitPrice?.cancellationCharges, updateUnitPrice);
    handleClose();
    // } else {6
    //   errorTost("Please enter all values");
    // }
    // }
    // !!For Cancellation Charges Only
    // if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Cancellation Charges"]?.isAccessible && !loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Update Cancel Unit Price"]?.isAccessible) {
    //   returnRes(updateUnitPrice);
    // }
  }

  function closeModal() {
    handleClose();
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Confirm Cancel Unit</div>
        </div>
        {/* <div className={cssClasses.wrapperContent}>
              <div className={cssClasses.wrapperBlock}>
                <CustomInput
                  style={{ textTransform: "uppercase" }}
                  value={"₹"+numberWithCommas(updateUnitPrice.cancellationCharges)}
                  label={"Cancellation Charges"}
                  // inputType={"number"}
                  mandatory={false}
                  disabled={true}
                  // !!Removed no manual values
                  // handleChange={(e) => {
                  //   if(data?.paidamount<e){
                  //     setHelperText((pre)=>{
                  //       pre.cancellationCharges=`Cancellation charges cannot be more than Amount Paid ₹${data?.paidamount}`;
                  //       return {...pre}
                  //     });
                  //   }else{
                  //     setHelperText((pre)=>{
                  //       pre.cancellationCharges='';
                  //       return {...pre}
                  //     });
                  //   }
                  //   setUpdateUnitPrice((pre) => {
                  //     console.log(pre);
                  //     pre.cancellationCharges = parseInt(e);
                  //     return { ...pre };
                  //   });
                  // }}
                  // placeholder="Enter  Cancellation Charges"
                helperText={helperText.cancellationCharges}
                />
              </div>
              <div className={cssClasses.wrapperBlock}>
                    {data?.paidamount&&(
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={ "₹" + numberWithCommas(data?.paidamount)}
                        label={"Paid Amount"}
                        disabled={true}
                      />
                    )}
                </div>
              <div className={cssClasses.blockLabel} style={{width:'100%',textAlign:'left'}}>Breakdown of Paid Amount</div>
              <div className={cssClasses.wrapperBlock} >
                       {data?.paidamount?.sdr&&(
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={ "₹" + numberWithCommas(data?.paidamount?.sdr)}
                        label={"SDR"}
                        disabled={true}
                      />
                    )}
                </div>
                <div className={cssClasses.wrapperBlock} >
                       {data?.paidamount?.ocr&&(
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={ "₹" + numberWithCommas(data?.paidamount?.ocr)}
                        label={"OCR"}
                        disabled={true}
                      />
                    )}
                </div>
                <div className={cssClasses.wrapperBlock} >
                       {data?.paidamount?.gst&&(
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={ "₹" + numberWithCommas(data?.paidamount?.gst)}
                        label={"GST"}
                        disabled={true}
                      />
                    )}
                </div>
                <div className={cssClasses.wrapperBlock} >
                       {data?.paidamount?.gst&&(
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={ "₹" + numberWithCommas(data?.paidamount?.sdr+data?.paidamount?.ocr+data?.paidamount?.gst)}
                        label={"Total"}
                        disabled={true}
                      />
                    )}
                </div>
                <div className={cssClasses.wrapperBlock} >
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={   new Date(data?.last_updated_at).toDateString()}
                        label={"Allotment Date"}
                        disabled={true}
                      />
                </div>
                <div className={cssClasses.wrapperBlock} >
                      <CustomInput
                        style={{ textTransform: "uppercase" }}
                        value={new Date(data?.created_at).toDateString()}
                        label={"Payment Completion Date"}
                        disabled={true}
                      />
                </div>
                 <div className={cssClasses.wrapperBlock} style={{width:'100%'}}>
                <div className={cssClasses.blockLabel}   style={{ width: "100%", textAlign: "left" }}>{cancellationPercentageMsg}</div> 
                </div>
        </div> */}

        {/* New UI Added*/}

        <div className={cssClasses.wrapperContent}>
          {/* <div>
        <div>{data?.unitData?.wingId?.wingName}-{data?.unitData?.unitNo}</div>
       </div> */}

          {data?.unitCost ? <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              fontSize: "1.4rem",
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              lineHeight: "2.4rem",
              width: "100%",
              flexWrap: "wrap",
              gap: "0.5rem",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontFamily: "Inter-Medium",
                lineHeight: "2.4rem",
                width: "100%",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              {data?.leadId?.personId?.name ?? leadData?.leadname}
              {data?.leadId?.leadDisplayId ? (
                <span
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#667085",
                    fontWeight: "400",
                    fontFamily: "Inter-Regular",
                    lineHeight: " 1.8rem",
                  }}
                >
                  {"VJ" +
                    data?.leadId?.leadDisplayId?.replace(
                      data?.leadId?.leadDisplayId?.substring(8, 12),
                      "-" + data?.leadId?.leadDisplayId?.substring(8, 12)
                    )}
                </span>
              ) : (
                <span
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#667085",
                    fontWeight: "400",
                    fontFamily: "Inter-Regular",
                    lineHeight: " 1.8rem",
                  }}
                >
                  {"VJ" +
                    leadData?.leaddisplayid?.replace(
                      leadData?.leaddisplayid?.substring(8, 12),
                      "-" + leadData?.leaddisplayid?.substring(8, 12)
                    )}
                </span>
              )}
            </div>
            <div>
              <span>
                {data?.unitData?.projectId?.projectName ??
                  data?.unitId?.projectId?.projectName}
                |
              </span>
              <span>
                {/* {data?.unitData?.wingId?.wingName ??
                  data?.unitId?.wingId?.wingName} */}

                {data?.unitData?.wingId?.displayName ? data?.unitData?.wingId?.displayName : data?.unitData?.wingId?.wingName ??
                  data?.unitId?.wingId?.wingName}
                |
              </span>
              <span>{data?.unitData?.unitNo ?? data?.unitId?.unitNo}</span>
            </div>
          </div> : <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              fontSize: "1.4rem",
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              lineHeight: "2.4rem",
              width: "100%",
              flexWrap: "wrap",
              gap: "0.5rem",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontFamily: "Inter-Medium",
                lineHeight: "2.4rem",
                width: "100%",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              {data?.leadname}
              {data?.leaddisplayid ? (
                <span
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#667085",
                    fontWeight: "400",
                    fontFamily: "Inter-Regular",
                    lineHeight: " 1.8rem",
                  }}
                >
                  {"VJ" +
                    data?.leaddisplayid?.replace(
                      data?.leaddisplayid?.substring(8, 12),
                      "-" + data?.leaddisplayid?.substring(8, 12)
                    )}
                </span>
              ) : (
                <span
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#667085",
                    fontWeight: "400",
                    fontFamily: "Inter-Regular",
                    lineHeight: " 1.8rem",
                  }}
                >
                  {"VJ" +
                    leadData?.leaddisplayid?.replace(
                      leadData?.leaddisplayid?.substring(8, 12),
                      "-" + leadData?.leaddisplayid?.substring(8, 12)
                    )}
                </span>
              )}
            </div>
            <div>
              <span>
                {data?.projectname ??
                  data?.projectname}{" "}
                |{" "}
              </span>
              <span>
                {/* {data?.unitData?.wingId?.wingName ??
                  data?.unitId?.wingId?.wingName} */}
                {data?.unitData?.wingId?.displayName
                  ? data?.unitData?.wingId?.displayName
                  : data?.wingname ??
                  data?.wingname}{" "}
                |{" "}
              </span>
              <span>{data?.unitno ?? data?.unitno}</span>
            </div>
          </div>}
          {data?.unitCost ? <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.4rem",
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              lineHeight: "2.4rem",
              width: "100%",
              flexWrap: "wrap",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "0.5rem",
            }}
          >
            <div>
              <span>Alloted On:</span>
              <span style={{ color: "#344054", marginLeft: "0.5rem" }}>
                {new Date(data.created_at).toDateString()},{" "}
                {new Date(data.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
            {data?.status !== "Payment Pending" && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <span>First payment date:</span>
                <span style={{ color: "#344054", marginLeft: "0.5rem" }}>
                  {new Date(data.firstPaymentDate).toDateString()},{" "}
                  {new Date(data.firstPaymentDate).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
            )}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <span>Cancellation Request date:</span>
              <span style={{ color: "#344054", marginLeft: "0.5rem" }}>
                {cancellationRequest === undefined ||
                  cancellationRequest === null
                  ? data?.cancelUnitRequests?.length > 0
                    ? new Date(
                      data?.cancelUnitRequests[0]?.created_at
                    ).toDateString() +
                    "," +
                    " " +
                    new Date(
                      data?.cancelUnitRequests[0]?.created_at
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : new Date().toDateString() +
                    "," +
                    " " +
                    new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "-"}
              </span>
            </div>
          </div> : <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.4rem",
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              lineHeight: "2.4rem",
              width: "100%",
              flexWrap: "wrap",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "0.5rem",
            }}
          >
            <div>
              <span>Alloted On:</span>
              <span style={{ color: "#344054", marginLeft: "0.5rem" }}>
                {data?.created_at
                  ? new Date(data.created_at).toDateString() +
                  "," +
                  " " +
                  new Date(data.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                  : "-"}
              </span>
            </div>
            {data?.status !== "Payment Pending" && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <span>First payment date:</span>
                <span style={{ color: "#344054", marginLeft: "0.5rem" }}>
                  {data?.firstpaymentdate
                    ? new Date(data.firstpaymentdate).toDateString() +
                    "," +
                    " " +
                    new Date(data.firstpaymentdate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : "-"}
                </span>
              </div>
            )}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <span>Cancellation Request date:</span>
              <span style={{ color: "#344054", marginLeft: "0.5rem" }}>
                {cancellationRequest === undefined ||
                  cancellationRequest === null
                  ? data?.cancelUnitRequests?.length > 0
                    ? new Date(
                      data?.cancelUnitRequests[0]?.created_at
                    ).toDateString() +
                    "," +
                    " " +
                    new Date(
                      data?.cancelUnitRequests[0]?.created_at
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : new Date().toDateString() +
                    "," +
                    " " +
                    new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : data?.cancelunitrequestcreatedat
                    ? new Date(data?.cancelunitrequestcreatedat).toDateString() +
                    "," +
                    " " +
                    new Date(data?.cancelunitrequestcreatedat).toLocaleTimeString(
                      [],
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                    : "-"}
              </span>
            </div>
          </div>}
          {data?.unitCost ? <div
            style={{
              borderRadius: "0.5rem",
              background: "#F9FAFB",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.4rem",
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              lineHeight: "2.4rem",
              gap: "1rem",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontFamily: "Inter-Medium",
                lineHeight: "2.4rem",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "7px",
              }}
            >
              <span>Paid Amount:</span>
              <span style={{ color: "#374151", marginLeft: "0.5rem" }}>
                ₹{numberWithCommas(data?.paidAmount)}
              </span>
            </div>

            <div
              style={{
                fontSize: "1.6rem",
                fontFamily: "Inter-Medium",
                lineHeight: "2.4rem",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "7px",
              }}
            >
              <span>Cancellation Charges:</span>
              <span
                style={{
                  color: "#374151",
                  marginLeft: "0.5rem",
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                }}
              >
                ₹
                {(data?.unitId?.farvisionStatus === "Hold" || data?.unitData?.farvisionStatus === "Hold") ? (
                  <div style={{ width: "150px" }}>
                    <CustomInput
                      label={""}
                      placeholder={""}
                      inputType={"number"}
                      value={updateUnitPrice.cancellationCharges}
                      handleChange={(_value) => {
                        if (_value === "") {
                          const payload = { ...updateUnitPrice };
                          payload.cancellationCharges = null;
                          setUpdateUnitPrice(payload);
                        } else {
                          const payload = { ...updateUnitPrice };
                          payload.cancellationCharges = parseInt(_value);
                          setUpdateUnitPrice(payload);
                        }
                      }}
                      disabled={waiveOffValue}
                    />
                  </div>
                ) : (
                  numberWithCommas(updateUnitPrice?.cancellationCharges)
                )}
              </span>
            </div>
          </div> : <div
            style={{
              borderRadius: "0.5rem",
              background: "#F9FAFB",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.4rem",
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              lineHeight: "2.4rem",
              gap: "1rem",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                fontSize: "1.6rem",
                fontFamily: "Inter-Medium",
                lineHeight: "2.4rem",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "7px",
              }}
            >
              <span>Paid Amount:</span>
              <span style={{ color: "#374151", marginLeft: "0.5rem" }}>
                ₹{numberWithCommas(data?.paidamount)}
              </span>
            </div>

            <div
              style={{
                fontSize: "1.6rem",
                fontFamily: "Inter-Medium",
                lineHeight: "2.4rem",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "7px",
              }}
            >
              <span>Cancellation Charges:</span>
              <span
                style={{
                  color: "#374151",
                  marginLeft: "0.5rem",
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                }}
              >
                ₹
                {(data?.farvisionstatus === "Hold" ||
                  data?.farvisionstatus === "Hold") ? (
                  <div style={{ width: "150px" }}>
                    <CustomInput
                      label={""}
                      placeholder={""}
                      inputType={"number"}
                      value={updateUnitPrice.cancellationCharges}
                      handleChange={(_value) => {
                        if (_value === "") {
                          const payload = { ...updateUnitPrice };
                          payload.cancellationCharges = null;
                          setUpdateUnitPrice(payload);
                        } else {
                          const payload = { ...updateUnitPrice };
                          payload.cancellationCharges = parseInt(_value);
                          setUpdateUnitPrice(payload);
                        }
                      }}
                      disabled={waiveOffValue}
                    />
                  </div>
                ) : (
                  numberWithCommas(updateUnitPrice.cancellationCharges)
                )}
              </span>
            </div>
          </div>}
          {/* <div style={{
          borderRadius: '0.5rem',
          background:'#F9FAFB',
          display:'flex',
          justifyContent:'space-between',
          fontSize:'1.4rem',
          fontFamily: 'Inter-Medium',
          fontWeight: '500',
          lineHeight: '2.4rem',
          gap:'1rem',
          flexDirection:'column',
          width:'100%'
        }}>
          <div className={cssClasses.wrapperRow}>
            <span>SDR :</span>
            <span>₹{numberWithCommas(data?.paidamount?.sdr)}</span>
          </div>
          <div className={cssClasses.wrapperRow}>
            <span>OCR :</span>
            <span>₹{numberWithCommas(data?.paidamount?.ocr)}</span>
          </div>
          <div className={cssClasses.wrapperRow}>
            <span>GST :</span>
            <span>₹{numberWithCommas(data?.paidamount?.gst)}</span>
          </div>
          <div className={cssClasses.wrapperRow}>
            <span>Cancellation Charges :</span>
            <span>₹{numberWithCommas(updateUnitPrice.cancellationCharges)}</span>
          </div>
          <div className={cssClasses.border}></div>
          <div className={cssClasses.wrapperRow}>
            <span>Total Paid Amount:</span>
            <span>₹{numberWithCommas(data?.paidamount?.sdr+data?.paidamount?.ocr+data?.paidamount?.gst)}</span>
          </div>
        </div> */}
          {data?.unitCost ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "70%",
              }}
            >
              {!cancellationRequest?.cancelledInFarvision && (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                    }
                    checked={holdRefund}
                    label={
                      <div className={classes.radioLabel}>Hold Refund</div>
                    }
                    onChange={(e) => {
                      setHoldRefund(!holdRefund);
                    }}
                  />
                </FormGroup>
              )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "70%",
              }}
            >
              {!cancellationRequest?.cancelledinfarvision && (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                    }
                    checked={holdRefund}
                    label={
                      <div className={classes.radioLabel}>Hold Refund</div>
                    }
                    onChange={(e) => {
                      setHoldRefund(!holdRefund);
                    }}
                  />
                </FormGroup>
              )}
            </div>
          )}
          {data?.reason && (
            <div style={{ width: "100%" }}>
              <span style={{ color: "red", fontFamily: "Inter-Medium", fontWeight: "500", fontSize: "1.4rem" }}>
                Cancellation Reason: {data.reason}
              </span>
            </div>
          )}
          {(updateUnitPrice?.cancellationCharges !== 0 &&
            updateUnitPrice?.cancellationCharges !== null) && !cancellationRequest?.cancelledinfarvision && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {(isUserAccess) && (
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                        />
                      }
                      checked={waiveOffValue}
                      label={<div className={classes.radioLabel}>Waive Off</div>}
                      onChange={(e) => {
                        waiveOff(e.target.checked);
                      }}
                    />
                  </FormGroup>
                )}
                {waiveOffValue && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "end",
                      gap: "4rem",
                      marginLeft: "0.5rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        transform: "scale(1.2)",
                        marginLeft: "1.5rem",
                      }}
                    >
                      <CustomRadio
                        value={waiveOpt ? "Full" : "Partial"}
                        optionList={["Full", "Partial"]}
                        onChangeValue={(e) => {
                          setWaiveOpt(e === "Full" ? true : false);
                          if (e === "Full") {
                            const payload = { ...updateUnitPrice };
                            payload.waivedOffCancellationCharges = parseInt(
                              payload.cancellationCharges
                            );
                            payload.newCancellationCharges = 0;
                            setUpdateUnitPrice(payload);
                          } else {
                            const payload = { ...updateUnitPrice };
                            payload.waivedOffCancellationCharges = null;
                            payload.newCancellationCharges = 0;
                            setUpdateUnitPrice(payload);
                          }
                        }}
                      />
                    </div>
                    {!waiveOpt && (
                      <div>
                        <div style={{ width: "150px" }}>
                          <CustomInput
                            label={"WaiveOff Amount :"}
                            placeholder={""}
                            inputType={"number"}
                            value={updateUnitPrice.waivedOffCancellationCharges}
                            handleChange={(_value) => {
                              if (_value === "") {
                                const payload = { ...updateUnitPrice };
                                payload.waivedOffCancellationCharges = null;
                                payload.newCancellationCharges = 0;
                                setUpdateUnitPrice(payload);
                              } else if (
                                parseInt(updateUnitPrice.cancellationCharges) >
                                parseInt(_value)
                              ) {
                                const payload = { ...updateUnitPrice };
                                payload.waivedOffCancellationCharges =
                                  parseInt(_value);
                                payload.newCancellationCharges =
                                  parseInt(payload.cancellationCharges) -
                                  parseInt(_value);
                                setUpdateUnitPrice(payload);
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {!waiveOpt && waiveOffValue && <div
                  className={cssClasses.blockLabel}
                  style={{ width: "100%", textAlign: "left", color: "red", marginTop: "1.5rem" }}
                >Waived off amount should not greater than {updateUnitPrice?.cancellationCharges}!</div>}
              </div>
            )}
          {(updateUnitPrice?.cancellationCharges !== 0 &&
            updateUnitPrice?.cancellationCharges !== null) && isUserAccess && waiveOffValue && <div
              className={cssClasses.wrapperBlock}
              style={{ width: "100%", textAlign: "left" }}
            >
              <div
                className={cssClasses.blockLabel}
                style={{ width: "100%", textAlign: "left" }}
              >
                Reason:
                <span style={{ color: "red" }}> *</span>
                <div style={{ width: "100%", marginTop: "1rem" }}>
                  <TextField
                    maxRows={4}
                    value={updateUnitPrice?.waivedOffReason}
                    onChange={(e) => {
                      e.target.value = e.target.value.trimStart();
                      if (e.target.value.length <= 200) {
                        setUpdateUnitPrice((pre) => {
                          pre.waivedOffReason = e.target.value;
                          return { ...pre };
                        });
                      }
                      if (e.target.value.length === 0) {
                        setHelperText((pre) => {
                          pre.waivedOffReason = "Please enter reason";
                          return { ...pre };
                        });
                      } else {
                        setHelperText((pre) => {
                          pre.waivedOffReason = "";
                          return { ...pre };
                        });
                      }
                    }}
                    placeholder={"Type..."}
                    helperText={helperText.waivedOffReason}
                    error={helperText.waivedOffReason !== ""}
                    className={classes.TextFieldStyle}
                    InputProps={{
                      className: classes.inputStyle,
                    }}
                    inputProps={{ min: 0 }}
                    FormHelperTextProps={{ className: classes.helperText }}
                    multiline
                  />
                </div>
              </div>
            </div>}

          {(data?.farvisionstatus !== "Hold" ||
            data?.farvisionstatus !== "Hold") && (
              <div
                className={cssClasses.blockLabel}
                style={{ width: "100%", textAlign: "left", color: "red" }}
              >
                {cancellationPercentageMsg !== null
                  ? `*${cancellationPercentageMsg}`
                  : ""}
              </div>
            )}
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={closeModal}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              disable={
                // !loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Cancellation Charges"]
                // &&
                // !loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
                // "Update Cancel Unit Price"
                // ]
                // ||
                helperText.cancellationCharges !== "" ||
                ((updateUnitPrice?.cancellationCharges !== 0 &&
                  updateUnitPrice?.cancellationCharges !== null) && isUserAccess && waiveOffValue && updateUnitPrice?.waivedOffReason === "") ||
                (!waiveOpt &&
                  updateUnitPrice?.waivedOffCancellationCharges === null)
              }
              btnName={"Accept"}
              clicked={() => {
                // save('acceptWithRefund');
                if (!cancellationRequest?.cancelledinfarvision) {
                  if (holdRefund) {
                    setTitleForAlert(
                      "Are you sure you want to cancel your unit without refund?"
                    );
                  } else {
                    setTitleForAlert(
                      "Are you sure you want to cancel your unit with refund?"
                    );
                  }
                } else {
                  setTitleForAlert("Are you sure you want to cancel?");
                }
                setOpenAlertBoxForCancellation(true);
              }}
            />
          </div>
          {/* <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              disable={
                // !loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Cancellation Charges"] 
                // &&
                // !loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
                // "Update Cancel Unit Price"
                // ]
                // ||
                helperText.cancellationCharges!==''
              }
              btnName={"Accept without Refund"}
              clicked={() => {
                save('acceptWithoutRefund');
              }}
            />
          </div> */}
          {openAlertBoxForCancellation && (
            <ConfirmationAlert
              hideCloseIcon={true}
              confirm={(e) => {
                if (e === "confirmed") {
                  if (holdRefund) {
                    save("acceptWithoutRefund");
                  } else {
                    save("acceptWithRefund");
                  }
                  setOpenAlertBoxForCancellation(false);
                }
              }}
              buttonTitle={"No"}
              returnRespButton={"Yes"}
              close={() => setOpenAlertBoxForCancellation(false)}
              title={"Info"}
              subTitle={titleForAlert}
              open={openAlertBoxForCancellation}
            />
          )}
        </div>
      </Box>
    </Modal>
  );
}
